export default {
    props: {
        seriesAggregate: {
            type: String | Function,
            kComposite: 'series.aggregate'
        }, 
        seriesAxis: {
            type: String,
            kComposite: 'series.axis'
        }, 
        seriesBorderColor: {
            type: String | Function,
            kComposite: 'series.border.color'
        }, 
        seriesBorderDashType: {
            type: String | Function,
            kComposite: 'series.border.dashType'
        }, 
        seriesBorderOpacity: {
            type: Number | Function,
            kComposite: 'series.border.opacity'
        }, 
        seriesBorderWidth: {
            type: Number | Function,
            kComposite: 'series.border.width'
        }, 
        seriesCategoryAxis: {
            type: String,
            kComposite: 'series.categoryAxis'
        }, 
        seriesCategoryField: {
            type: String,
            kComposite: 'series.categoryField'
        }, 
        seriesCloseField: {
            type: String,
            kComposite: 'series.closeField'
        }, 
        seriesColor: {
            type: String | Function,
            kComposite: 'series.color'
        }, 
        seriesColorField: {
            type: String,
            kComposite: 'series.colorField'
        }, 
        seriesConnectorsColor: {
            type: String | Function,
            kComposite: 'series.connectors.color'
        }, 
        seriesConnectorsPadding: {
            type: Number,
            kComposite: 'series.connectors.padding'
        }, 
        seriesConnectorsWidth: {
            type: Number,
            kComposite: 'series.connectors.width'
        }, 
        seriesCurrentField: {
            type: String,
            kComposite: 'series.currentField'
        }, 
        seriesDashType: {
            type: String,
            kComposite: 'series.dashType'
        }, 
        seriesData: {
            type: Array,
            kComposite: 'series.data'
        }, 
        seriesDownColor: {
            type: String | Function,
            kComposite: 'series.downColor'
        }, 
        seriesDownColorField: {
            type: String,
            kComposite: 'series.downColorField'
        }, 
        seriesSegmentSpacing: {
            type: Number,
            kComposite: 'series.segmentSpacing'
        }, 
        seriesSummaryField: {
            type: String,
            kComposite: 'series.summaryField'
        }, 
        seriesNeckRatio: {
            type: Number,
            kComposite: 'series.neckRatio'
        }, 
        seriesDynamicSlope: {
            type: Boolean,
            kComposite: 'series.dynamicSlope'
        }, 
        seriesDynamicHeight: {
            type: Boolean,
            kComposite: 'series.dynamicHeight'
        }, 
        seriesErrorBarsValue: {
            type: String | Number | Array | Function,
            kComposite: 'series.errorBars.value'
        }, 
        seriesErrorBarsVisual: {
            type: Function,
            kComposite: 'series.errorBars.visual'
        }, 
        seriesErrorBarsXValue: {
            type: String | Number | Array | Function,
            kComposite: 'series.errorBars.xValue'
        }, 
        seriesErrorBarsYValue: {
            type: String | Number | Array | Function,
            kComposite: 'series.errorBars.yValue'
        }, 
        seriesErrorBarsEndCaps: {
            type: Boolean,
            kComposite: 'series.errorBars.endCaps'
        }, 
        seriesErrorBarsColor: {
            type: String,
            kComposite: 'series.errorBars.color'
        }, 
        seriesErrorBarsLineWidth: {
            type: Number,
            kComposite: 'series.errorBars.line.width'
        }, 
        seriesErrorBarsLineDashType: {
            type: String,
            kComposite: 'series.errorBars.line.dashType'
        }, 
        seriesErrorLowField: {
            type: String,
            kComposite: 'series.errorLowField'
        }, 
        seriesErrorHighField: {
            type: String,
            kComposite: 'series.errorHighField'
        }, 
        seriesXErrorLowField: {
            type: String,
            kComposite: 'series.xErrorLowField'
        }, 
        seriesXErrorHighField: {
            type: String,
            kComposite: 'series.xErrorHighField'
        }, 
        seriesYErrorLowField: {
            type: String,
            kComposite: 'series.yErrorLowField'
        }, 
        seriesYErrorHighField: {
            type: String,
            kComposite: 'series.yErrorHighField'
        }, 
        seriesExplodeField: {
            type: String,
            kComposite: 'series.explodeField'
        }, 
        seriesField: {
            type: String,
            kComposite: 'series.field'
        }, 
        seriesFromField: {
            type: String,
            kComposite: 'series.fromField'
        }, 
        seriesToField: {
            type: String,
            kComposite: 'series.toField'
        }, 
        seriesNoteTextField: {
            type: String,
            kComposite: 'series.noteTextField'
        }, 
        seriesLowerField: {
            type: String,
            kComposite: 'series.lowerField'
        }, 
        seriesQ1Field: {
            type: String,
            kComposite: 'series.q1Field'
        }, 
        seriesMedianField: {
            type: String,
            kComposite: 'series.medianField'
        }, 
        seriesQ3Field: {
            type: String,
            kComposite: 'series.q3Field'
        }, 
        seriesUpperField: {
            type: String,
            kComposite: 'series.upperField'
        }, 
        seriesMeanField: {
            type: String,
            kComposite: 'series.meanField'
        }, 
        seriesOutliersField: {
            type: String,
            kComposite: 'series.outliersField'
        }, 
        seriesGap: {
            type: Number,
            kComposite: 'series.gap'
        }, 
        seriesHighField: {
            type: String,
            kComposite: 'series.highField'
        }, 
        seriesHighlightBorderColor: {
            type: String,
            kComposite: 'series.highlight.border.color'
        }, 
        seriesHighlightBorderOpacity: {
            type: Number,
            kComposite: 'series.highlight.border.opacity'
        }, 
        seriesHighlightBorderWidth: {
            type: Number,
            kComposite: 'series.highlight.border.width'
        }, 
        seriesHighlightColor: {
            type: String,
            kComposite: 'series.highlight.color'
        }, 
        seriesHighlightLineDashType: {
            type: String,
            kComposite: 'series.highlight.line.dashType'
        }, 
        seriesHighlightLineColor: {
            type: String,
            kComposite: 'series.highlight.line.color'
        }, 
        seriesHighlightLineOpacity: {
            type: Number,
            kComposite: 'series.highlight.line.opacity'
        }, 
        seriesHighlightLineWidth: {
            type: Number,
            kComposite: 'series.highlight.line.width'
        }, 
        seriesHighlightOpacity: {
            type: Number,
            kComposite: 'series.highlight.opacity'
        }, 
        seriesHighlightToggle: {
            type: Function,
            kComposite: 'series.highlight.toggle'
        }, 
        seriesHighlightVisible: {
            type: Boolean,
            kComposite: 'series.highlight.visible'
        }, 
        seriesHighlightVisual: {
            type: Function,
            kComposite: 'series.highlight.visual'
        }, 
        seriesHoleSize: {
            type: Number,
            kComposite: 'series.holeSize'
        }, 
        seriesLabelsAlign: {
            type: String,
            kComposite: 'series.labels.align'
        }, 
        seriesLabelsBackground: {
            type: String | Function,
            kComposite: 'series.labels.background'
        }, 
        seriesLabelsBorderColor: {
            type: String | Function,
            kComposite: 'series.labels.border.color'
        }, 
        seriesLabelsBorderDashType: {
            type: String | Function,
            kComposite: 'series.labels.border.dashType'
        }, 
        seriesLabelsBorderWidth: {
            type: Number | Function,
            kComposite: 'series.labels.border.width'
        }, 
        seriesLabelsColor: {
            type: String | Function,
            kComposite: 'series.labels.color'
        }, 
        seriesLabelsDistance: {
            type: Number,
            kComposite: 'series.labels.distance'
        }, 
        seriesLabelsFont: {
            type: String | Function,
            kComposite: 'series.labels.font'
        }, 
        seriesLabelsFormat: {
            type: String | Function,
            kComposite: 'series.labels.format'
        }, 
        seriesLabelsMargin: {
            type: Number,
            kComposite: 'series.labels.margin'
        }, 
        seriesLabelsMarginBottom: {
            type: Number,
            kComposite: 'series.labels.margin.bottom'
        }, 
        seriesLabelsMarginLeft: {
            type: Number,
            kComposite: 'series.labels.margin.left'
        }, 
        seriesLabelsMarginRight: {
            type: Number,
            kComposite: 'series.labels.margin.right'
        }, 
        seriesLabelsMarginTop: {
            type: Number,
            kComposite: 'series.labels.margin.top'
        }, 
        seriesLabelsPadding: {
            type: Number,
            kComposite: 'series.labels.padding'
        }, 
        seriesLabelsPaddingBottom: {
            type: Number,
            kComposite: 'series.labels.padding.bottom'
        }, 
        seriesLabelsPaddingLeft: {
            type: Number,
            kComposite: 'series.labels.padding.left'
        }, 
        seriesLabelsPaddingRight: {
            type: Number,
            kComposite: 'series.labels.padding.right'
        }, 
        seriesLabelsPaddingTop: {
            type: Number,
            kComposite: 'series.labels.padding.top'
        }, 
        seriesLabelsPosition: {
            type: String | Function,
            kComposite: 'series.labels.position'
        }, 
        seriesLabelsRotation: {
            type: String | Number,
            kComposite: 'series.labels.rotation'
        }, 
        seriesLabelsTemplate: {
            type: String | Function,
            kComposite: 'series.labels.template'
        }, 
        seriesLabelsVisible: {
            type: Boolean | Function,
            kComposite: 'series.labels.visible'
        }, 
        seriesLabelsVisual: {
            type: Function,
            kComposite: 'series.labels.visual'
        }, 
        seriesLabelsFromBackground: {
            type: String | Function,
            kComposite: 'series.labels.from.background'
        }, 
        seriesLabelsFromBorderColor: {
            type: String | Function,
            kComposite: 'series.labels.from.border.color'
        }, 
        seriesLabelsFromBorderDashType: {
            type: String | Function,
            kComposite: 'series.labels.from.border.dashType'
        }, 
        seriesLabelsFromBorderWidth: {
            type: Number | Function,
            kComposite: 'series.labels.from.border.width'
        }, 
        seriesLabelsFromColor: {
            type: String | Function,
            kComposite: 'series.labels.from.color'
        }, 
        seriesLabelsFromFont: {
            type: String | Function,
            kComposite: 'series.labels.from.font'
        }, 
        seriesLabelsFromFormat: {
            type: String | Function,
            kComposite: 'series.labels.from.format'
        }, 
        seriesLabelsFromMargin: {
            type: Number,
            kComposite: 'series.labels.from.margin'
        }, 
        seriesLabelsFromMarginBottom: {
            type: Number,
            kComposite: 'series.labels.from.margin.bottom'
        }, 
        seriesLabelsFromMarginLeft: {
            type: Number,
            kComposite: 'series.labels.from.margin.left'
        }, 
        seriesLabelsFromMarginRight: {
            type: Number,
            kComposite: 'series.labels.from.margin.right'
        }, 
        seriesLabelsFromMarginTop: {
            type: Number,
            kComposite: 'series.labels.from.margin.top'
        }, 
        seriesLabelsFromPadding: {
            type: Number,
            kComposite: 'series.labels.from.padding'
        }, 
        seriesLabelsFromPaddingBottom: {
            type: Number,
            kComposite: 'series.labels.from.padding.bottom'
        }, 
        seriesLabelsFromPaddingLeft: {
            type: Number,
            kComposite: 'series.labels.from.padding.left'
        }, 
        seriesLabelsFromPaddingRight: {
            type: Number,
            kComposite: 'series.labels.from.padding.right'
        }, 
        seriesLabelsFromPaddingTop: {
            type: Number,
            kComposite: 'series.labels.from.padding.top'
        }, 
        seriesLabelsFromPosition: {
            type: String | Function,
            kComposite: 'series.labels.from.position'
        }, 
        seriesLabelsFromTemplate: {
            type: String | Function,
            kComposite: 'series.labels.from.template'
        }, 
        seriesLabelsFromVisible: {
            type: Boolean | Function,
            kComposite: 'series.labels.from.visible'
        }, 
        seriesLabelsToBackground: {
            type: String | Function,
            kComposite: 'series.labels.to.background'
        }, 
        seriesLabelsToBorderColor: {
            type: String | Function,
            kComposite: 'series.labels.to.border.color'
        }, 
        seriesLabelsToBorderDashType: {
            type: String | Function,
            kComposite: 'series.labels.to.border.dashType'
        }, 
        seriesLabelsToBorderWidth: {
            type: Number | Function,
            kComposite: 'series.labels.to.border.width'
        }, 
        seriesLabelsToColor: {
            type: String | Function,
            kComposite: 'series.labels.to.color'
        }, 
        seriesLabelsToFont: {
            type: String | Function,
            kComposite: 'series.labels.to.font'
        }, 
        seriesLabelsToFormat: {
            type: String | Function,
            kComposite: 'series.labels.to.format'
        }, 
        seriesLabelsToMargin: {
            type: Number,
            kComposite: 'series.labels.to.margin'
        }, 
        seriesLabelsToMarginBottom: {
            type: Number,
            kComposite: 'series.labels.to.margin.bottom'
        }, 
        seriesLabelsToMarginLeft: {
            type: Number,
            kComposite: 'series.labels.to.margin.left'
        }, 
        seriesLabelsToMarginRight: {
            type: Number,
            kComposite: 'series.labels.to.margin.right'
        }, 
        seriesLabelsToMarginTop: {
            type: Number,
            kComposite: 'series.labels.to.margin.top'
        }, 
        seriesLabelsToPadding: {
            type: Number,
            kComposite: 'series.labels.to.padding'
        }, 
        seriesLabelsToPaddingBottom: {
            type: Number,
            kComposite: 'series.labels.to.padding.bottom'
        }, 
        seriesLabelsToPaddingLeft: {
            type: Number,
            kComposite: 'series.labels.to.padding.left'
        }, 
        seriesLabelsToPaddingRight: {
            type: Number,
            kComposite: 'series.labels.to.padding.right'
        }, 
        seriesLabelsToPaddingTop: {
            type: Number,
            kComposite: 'series.labels.to.padding.top'
        }, 
        seriesLabelsToPosition: {
            type: String | Function,
            kComposite: 'series.labels.to.position'
        }, 
        seriesLabelsToTemplate: {
            type: String | Function,
            kComposite: 'series.labels.to.template'
        }, 
        seriesLabelsToVisible: {
            type: Boolean | Function,
            kComposite: 'series.labels.to.visible'
        }, 
        seriesLine: {
            type: String,
            kComposite: 'series.line'
        }, 
        seriesLineColor: {
            type: String,
            kComposite: 'series.line.color'
        }, 
        seriesLineOpacity: {
            type: Number,
            kComposite: 'series.line.opacity'
        }, 
        seriesLineWidth: {
            type: String,
            kComposite: 'series.line.width'
        }, 
        seriesLineStyle: {
            type: String,
            kComposite: 'series.line.style'
        }, 
        seriesLowField: {
            type: String,
            kComposite: 'series.lowField'
        }, 
        seriesMargin: {
            type: Number,
            kComposite: 'series.margin'
        }, 
        seriesMarginBottom: {
            type: Number,
            kComposite: 'series.margin.bottom'
        }, 
        seriesMarginLeft: {
            type: Number,
            kComposite: 'series.margin.left'
        }, 
        seriesMarginRight: {
            type: Number,
            kComposite: 'series.margin.right'
        }, 
        seriesMarginTop: {
            type: Number,
            kComposite: 'series.margin.top'
        }, 
        seriesMarkersBackground: {
            type: String | Function,
            kComposite: 'series.markers.background'
        }, 
        seriesMarkersBorder: {
            type: Function,
            kComposite: 'series.markers.border'
        }, 
        seriesMarkersBorderColor: {
            type: String | Function,
            kComposite: 'series.markers.border.color'
        }, 
        seriesMarkersBorderWidth: {
            type: Number | Function,
            kComposite: 'series.markers.border.width'
        }, 
        seriesMarkersFromBackground: {
            type: String | Function,
            kComposite: 'series.markers.from.background'
        }, 
        seriesMarkersFromBorder: {
            type: Function,
            kComposite: 'series.markers.from.border'
        }, 
        seriesMarkersFromBorderColor: {
            type: String | Function,
            kComposite: 'series.markers.from.border.color'
        }, 
        seriesMarkersFromBorderWidth: {
            type: Number | Function,
            kComposite: 'series.markers.from.border.width'
        }, 
        seriesMarkersFromSize: {
            type: Number | Function,
            kComposite: 'series.markers.from.size'
        }, 
        seriesMarkersFromType: {
            type: String | Function,
            kComposite: 'series.markers.from.type'
        }, 
        seriesMarkersFromVisible: {
            type: Boolean | Function,
            kComposite: 'series.markers.from.visible'
        }, 
        seriesMarkersFromVisual: {
            type: Function,
            kComposite: 'series.markers.from.visual'
        }, 
        seriesMarkersFromRotation: {
            type: Number | Function,
            kComposite: 'series.markers.from.rotation'
        }, 
        seriesMarkersSize: {
            type: Number | Function,
            kComposite: 'series.markers.size'
        }, 
        seriesMarkersToBackground: {
            type: String | Function,
            kComposite: 'series.markers.to.background'
        }, 
        seriesMarkersToBorder: {
            type: Function,
            kComposite: 'series.markers.to.border'
        }, 
        seriesMarkersToBorderColor: {
            type: String | Function,
            kComposite: 'series.markers.to.border.color'
        }, 
        seriesMarkersToBorderWidth: {
            type: Number | Function,
            kComposite: 'series.markers.to.border.width'
        }, 
        seriesMarkersToSize: {
            type: Number | Function,
            kComposite: 'series.markers.to.size'
        }, 
        seriesMarkersToType: {
            type: String | Function,
            kComposite: 'series.markers.to.type'
        }, 
        seriesMarkersToVisible: {
            type: Boolean | Function,
            kComposite: 'series.markers.to.visible'
        }, 
        seriesMarkersToVisual: {
            type: Function,
            kComposite: 'series.markers.to.visual'
        }, 
        seriesMarkersToRotation: {
            type: Number | Function,
            kComposite: 'series.markers.to.rotation'
        }, 
        seriesMarkersType: {
            type: String | Function,
            kComposite: 'series.markers.type'
        }, 
        seriesMarkersVisible: {
            type: Boolean | Function,
            kComposite: 'series.markers.visible'
        }, 
        seriesMarkersVisual: {
            type: Function,
            kComposite: 'series.markers.visual'
        }, 
        seriesMarkersRotation: {
            type: Number | Function,
            kComposite: 'series.markers.rotation'
        }, 
        seriesOutliersBackground: {
            type: String | Function,
            kComposite: 'series.outliers.background'
        }, 
        seriesOutliersBorder: {
            type: Function,
            kComposite: 'series.outliers.border'
        }, 
        seriesOutliersBorderColor: {
            type: String | Function,
            kComposite: 'series.outliers.border.color'
        }, 
        seriesOutliersBorderWidth: {
            type: Number | Function,
            kComposite: 'series.outliers.border.width'
        }, 
        seriesOutliersSize: {
            type: Number | Function,
            kComposite: 'series.outliers.size'
        }, 
        seriesOutliersType: {
            type: String | Function,
            kComposite: 'series.outliers.type'
        }, 
        seriesOutliersRotation: {
            type: Number | Function,
            kComposite: 'series.outliers.rotation'
        }, 
        seriesExtremesBackground: {
            type: String | Function,
            kComposite: 'series.extremes.background'
        }, 
        seriesExtremesBorder: {
            type: Function,
            kComposite: 'series.extremes.border'
        }, 
        seriesExtremesBorderColor: {
            type: String | Function,
            kComposite: 'series.extremes.border.color'
        }, 
        seriesExtremesBorderWidth: {
            type: Number | Function,
            kComposite: 'series.extremes.border.width'
        }, 
        seriesExtremesSize: {
            type: Number | Function,
            kComposite: 'series.extremes.size'
        }, 
        seriesExtremesType: {
            type: String | Function,
            kComposite: 'series.extremes.type'
        }, 
        seriesExtremesRotation: {
            type: Number | Function,
            kComposite: 'series.extremes.rotation'
        }, 
        seriesMaxSize: {
            type: Number,
            kComposite: 'series.maxSize'
        }, 
        seriesMinSize: {
            type: Number,
            kComposite: 'series.minSize'
        }, 
        seriesMissingValues: {
            type: String,
            kComposite: 'series.missingValues'
        }, 
        seriesStyle: {
            type: String,
            kComposite: 'series.style'
        }, 
        seriesName: {
            type: String,
            kComposite: 'series.name'
        }, 
        seriesNegativeColor: {
            type: String,
            kComposite: 'series.negativeColor'
        }, 
        seriesNegativeValuesColor: {
            type: String,
            kComposite: 'series.negativeValues.color'
        }, 
        seriesNegativeValuesVisible: {
            type: Boolean,
            kComposite: 'series.negativeValues.visible'
        }, 
        seriesOpacity: {
            type: Number,
            kComposite: 'series.opacity'
        }, 
        seriesOpenField: {
            type: String,
            kComposite: 'series.openField'
        }, 
        seriesOverlayGradient: {
            type: String,
            kComposite: 'series.overlay.gradient'
        }, 
        seriesPadding: {
            type: Number,
            kComposite: 'series.padding'
        }, 
        seriesSize: {
            type: Number,
            kComposite: 'series.size'
        }, 
        seriesSizeField: {
            type: String,
            kComposite: 'series.sizeField'
        }, 
        seriesSpacing: {
            type: Number,
            kComposite: 'series.spacing'
        }, 
        seriesStack: {
            type: Boolean | String,
            kComposite: 'series.stack'
        }, 
        seriesStackType: {
            type: String,
            kComposite: 'series.stack.type'
        }, 
        seriesStackGroup: {
            type: String,
            kComposite: 'series.stack.group'
        }, 
        seriesStartAngle: {
            type: Number,
            kComposite: 'series.startAngle'
        }, 
        seriesTargetBorder: {
            type: Function,
            kComposite: 'series.target.border'
        }, 
        seriesTargetBorderColor: {
            type: String | Function,
            kComposite: 'series.target.border.color'
        }, 
        seriesTargetBorderDashType: {
            type: String | Function,
            kComposite: 'series.target.border.dashType'
        }, 
        seriesTargetBorderWidth: {
            type: Number | Function,
            kComposite: 'series.target.border.width'
        }, 
        seriesTargetColor: {
            type: String | Function,
            kComposite: 'series.target.color'
        }, 
        seriesTargetLineWidth: {
            type: Object | Function,
            kComposite: 'series.target.line.width'
        }, 
        seriesTargetField: {
            type: String,
            kComposite: 'series.targetField'
        }, 
        seriesTooltipBackground: {
            type: String,
            kComposite: 'series.tooltip.background'
        }, 
        seriesTooltipBorderColor: {
            type: String,
            kComposite: 'series.tooltip.border.color'
        }, 
        seriesTooltipBorderWidth: {
            type: Number,
            kComposite: 'series.tooltip.border.width'
        }, 
        seriesTooltipColor: {
            type: String,
            kComposite: 'series.tooltip.color'
        }, 
        seriesTooltipFont: {
            type: String,
            kComposite: 'series.tooltip.font'
        }, 
        seriesTooltipFormat: {
            type: String,
            kComposite: 'series.tooltip.format'
        }, 
        seriesTooltipPadding: {
            type: Number,
            kComposite: 'series.tooltip.padding'
        }, 
        seriesTooltipPaddingBottom: {
            type: Number,
            kComposite: 'series.tooltip.padding.bottom'
        }, 
        seriesTooltipPaddingLeft: {
            type: Number,
            kComposite: 'series.tooltip.padding.left'
        }, 
        seriesTooltipPaddingRight: {
            type: Number,
            kComposite: 'series.tooltip.padding.right'
        }, 
        seriesTooltipPaddingTop: {
            type: Number,
            kComposite: 'series.tooltip.padding.top'
        }, 
        seriesTooltipTemplate: {
            type: String | Function,
            kComposite: 'series.tooltip.template'
        }, 
        seriesTooltipVisible: {
            type: Boolean,
            kComposite: 'series.tooltip.visible'
        }, 
        seriesType: {
            type: String,
            kComposite: 'series.type'
        }, 
        seriesVisible: {
            type: Boolean,
            kComposite: 'series.visible'
        }, 
        seriesVisibleInLegend: {
            type: Boolean,
            kComposite: 'series.visibleInLegend'
        }, 
        seriesVisibleInLegendField: {
            type: String,
            kComposite: 'series.visibleInLegendField'
        }, 
        seriesVisual: {
            type: Function,
            kComposite: 'series.visual'
        }, 
        seriesWidth: {
            type: Number,
            kComposite: 'series.width'
        }, 
        seriesXAxis: {
            type: String,
            kComposite: 'series.xAxis'
        }, 
        seriesXField: {
            type: String,
            kComposite: 'series.xField'
        }, 
        seriesYAxis: {
            type: String,
            kComposite: 'series.yAxis'
        }, 
        seriesYField: {
            type: String,
            kComposite: 'series.yField'
        }, 
        seriesNotesPosition: {
            type: String,
            kComposite: 'series.notes.position'
        }, 
        seriesNotesIconBackground: {
            type: String,
            kComposite: 'series.notes.icon.background'
        }, 
        seriesNotesIconBorderColor: {
            type: String,
            kComposite: 'series.notes.icon.border.color'
        }, 
        seriesNotesIconBorderWidth: {
            type: Number,
            kComposite: 'series.notes.icon.border.width'
        }, 
        seriesNotesIconSize: {
            type: Number,
            kComposite: 'series.notes.icon.size'
        }, 
        seriesNotesIconType: {
            type: String,
            kComposite: 'series.notes.icon.type'
        }, 
        seriesNotesIconVisible: {
            type: Boolean,
            kComposite: 'series.notes.icon.visible'
        }, 
        seriesNotesLabelBackground: {
            type: String,
            kComposite: 'series.notes.label.background'
        }, 
        seriesNotesLabelBorderColor: {
            type: String,
            kComposite: 'series.notes.label.border.color'
        }, 
        seriesNotesLabelBorderDashType: {
            type: String,
            kComposite: 'series.notes.label.border.dashType'
        }, 
        seriesNotesLabelBorderWidth: {
            type: Number,
            kComposite: 'series.notes.label.border.width'
        }, 
        seriesNotesLabelColor: {
            type: String,
            kComposite: 'series.notes.label.color'
        }, 
        seriesNotesLabelFont: {
            type: String,
            kComposite: 'series.notes.label.font'
        }, 
        seriesNotesLabelTemplate: {
            type: String | Function,
            kComposite: 'series.notes.label.template'
        }, 
        seriesNotesLabelVisible: {
            type: Boolean,
            kComposite: 'series.notes.label.visible'
        }, 
        seriesNotesLabelRotation: {
            type: Number,
            kComposite: 'series.notes.label.rotation'
        }, 
        seriesNotesLabelFormat: {
            type: String,
            kComposite: 'series.notes.label.format'
        }, 
        seriesNotesLabelPosition: {
            type: String,
            kComposite: 'series.notes.label.position'
        }, 
        seriesNotesLineDashType: {
            type: String,
            kComposite: 'series.notes.line.dashType'
        }, 
        seriesNotesLineWidth: {
            type: Number,
            kComposite: 'series.notes.line.width'
        }, 
        seriesNotesLineColor: {
            type: String,
            kComposite: 'series.notes.line.color'
        }, 
        seriesNotesLineLength: {
            type: Number,
            kComposite: 'series.notes.line.length'
        }, 
        seriesNotesVisual: {
            type: Function,
            kComposite: 'series.notes.visual'
        }, 
        seriesZIndex: {
            type: Number,
            kComposite: 'series.zIndex'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/Series.js